<style src="./Welcome.scss" lang="scss" scoped></style>
<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="image-logo-container">
      <img src="/static/images/logo.png" alt="Logo" class="image-logo" />
    </div>
    <div class="text">
      <h2>Bem vindo ao nosso Sistema de Gestão Integrado</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Welcome',
};
</script>
